// @ts-nocheck
import { SEND_CODE_ERROR, SEND_CODE_LOADING, SEND_CODE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const SendCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_CODE_LOADING:
            return Object.assign({}, state, { loading: true })
        case SEND_CODE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case SEND_CODE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

